// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-form-item-label {
  white-space: normal;
}
.ant-form-item-label label {
  display: inline-block;
  line-height: 1.3;
  margin-right: 12px;
}
.ant-form-item-label label:after {
  content: none !important;
}
.ant-btn {
  font-weight: 600;
}
.ant-btn {
  color: #00739D;
  box-shadow: #0086b6 0px 0px 0px 2px inset, rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;
  border: none;
}
.ant-btn.ant-btn-link {
  box-shadow: none;
  color: #00739D;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
}
.ant-btn.ant-btn-link:hover {
  background-color: #F2F2F2;
}
.ant-btn.ant-btn-link:active {
  background-color: #E6E6E6;
  font-weight: 600;
}
.ant-btn:focus-visible {
  border: 2px orange solid;
}
.ant-btn.ant-btn-primary {
  box-shadow: rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;
  color: #ffffff;
}
.ant-btn.ant-btn-primary:disabled {
  background-color: rgba(0, 115, 157, 0.5);
  color: #ffffff;
  cursor: auto;
}
.ant-btn.ant-btn-primary:disabled:hover {
  background-color: rgba(0, 115, 157, 0.5);
  color: #ffffff;
}
.ant-btn.ant-btn-primary:hover {
  background-color: #006083;
}
.ant-btn.ant-btn-primary:active {
  background-color: #00465F;
}
.ant-collapse-header {
  background-color: #ffffff;
}
.ant-radio-group {
  width: 100%;
  word-wrap: break-word;
}
.ant-table-row-expand-icon-cell {
  display: none;
}
.ant-hide-expand-icon-th th:first-child {
  display: none !important;
}
.ant-modal {
  overflow-y: hidden;
}
.ant-input-number-handler-wrap {
  display: none;
}
.ant-card {
  color: rgba(0, 0, 0, 0.85);
}
.ant-card-bordered {
  border: 1px solid #cfcfcf;
}
@media screen and (max-width: 600px) {
  .ant-card-body {
    padding: 10px 6px;
  }
}
.ant-input-number {
  width: 100%;
}
.ant-tooltip-inner {
  white-space: pre-wrap;
}
.ant-checkbox .ant-checkbox-inner {
  border-color: #006083;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/styles/antd-restyle.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAFA;EAGI,qBAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;AADI;EACE,wBAAA;AAGN;AAyBA;EACE,gBAAA;AAvBF;AA8BA;EAEE,cAAA;EACA,iFAAA;EACA,YAAA;AA7BF;AAgCA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA9BF;AA+BE;EACE,yBAAA;AA7BJ;AA+BE;EACE,yBAAA;EACA,gBAAA;AA7BJ;AAiCA;EACE,wBAAA;AA/BF;AAkCA;EACE,kDAAA;EACA,cAAA;AAhCF;AAiCE;EACE,wCAAA;EACA,cAAA;EACA,YAAA;AA/BJ;AAgCI;EACE,wCAAA;EACA,cAAA;AA9BN;AAiCE;EACE,yBAAA;AA/BJ;AAiCE;EACE,yBAAA;AA/BJ;AAoCA;EACE,yBAAA;AAlCF;AAqCA;EACE,WAAA;EACA,qBAAA;AAnCF;AAsCA;EACE,aAAA;AApCF;AAuCA;EACE,wBAAA;AArCF;AAwCA;EACE,kBAAA;AAtCF;AAyCA;EACE,aAAA;AAvCF;AA0CA;EACE,0BAAA;AAxCF;AA2CA;EACE,yBAAA;AAzCF;AA6CE;EAAA;IACE,iBAAA;EA1CF;AACF;AA6CA;EACE,WAAA;AA3CF;AA8CA;EACE,qBAAA;AA5CF;AA+CA;EACE,qBAAA;AA7CF","sourcesContent":[".ant-form-item-label {\n  white-space: normal;\n  label {\n    display: inline-block;\n    line-height: 1.3;\n    margin-right: 12px;\n    &:after {\n      content: none !important;\n    }\n  }\n}\n\n* {\n  //animation-duration: 500ms !important;\n}\n\n@text-primary-color: #28333F;\n\n@navigation-hover-background: #e8f9f7;\n\n@button-primary-color: rgb(255, 255, 255);\n\n@button-primary-bg-image: linear-gradient(\n  240deg,\n  rgb(0, 134, 182),\n  rgb(0, 115, 157)\n);\n@button-primary-border-color: rgb(0, 115, 157);\n@button-primary-box-shadow: rgba(40, 51, 63, 0.16) 0px 0px 1px 1px inset;\n@button-primary-background-color: #00739D;\n@button-primary-disabled-color:  rgba(0, 115, 157, 0.5);\n@button-primary-hover-color: #006083;\n@button-primary-active-color: #00465F;\n@button-tertiary-hover-color: #F2F2F2;\n@button-tertiary-active-color: #E6E6E6 ;\n.ant-btn {\n  font-weight: 600;\n  //color: @button-primary-color;\n  //background-image: @button-primary-bg-image;\n  //border-color: @button-primary-border-color;\n  //box-shadow: @button-primary-box-shadow;\n}\n\n.ant-btn {\n  //border: 2px;\n  color: @button-primary-background-color;\n  box-shadow:rgb(0, 134, 182) 0px 0px 0px 2px inset, rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;\n  border: none;\n}\n\n.ant-btn.ant-btn-link {\n  box-shadow: none;\n  color: @button-primary-background-color;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n  &:hover {\n    background-color: @button-tertiary-hover-color\n  }\n  &:active {\n    background-color: @button-tertiary-active-color;\n    font-weight: 600;\n  }\n}\n\n.ant-btn:focus-visible{\n  border: 2px orange solid;\n}\n\n.ant-btn.ant-btn-primary {\n  box-shadow: rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;\n  color: @button-primary-color;\n  &:disabled {\n    background-color:@button-primary-disabled-color;\n    color: @button-primary-color;\n    cursor: auto;\n    &:hover {\n      background-color: @button-primary-disabled-color;\n      color: @button-primary-color;\n    }\n  }\n  &:hover {\n    background-color: @button-primary-hover-color\n  }\n  &:active {\n    background-color: @button-primary-active-color\n  }\n}\n\n\n.ant-collapse-header {\n  background-color: #ffffff;\n}\n\n.ant-radio-group {\n  width: 100%;\n  word-wrap: break-word;\n}\n\n.ant-table-row-expand-icon-cell {\n  display: none;\n}\n\n.ant-hide-expand-icon-th th:first-child {\n  display: none !important;\n}\n\n.ant-modal {\n  overflow-y: hidden;\n}\n\n.ant-input-number-handler-wrap {\n  display: none;\n}\n\n.ant-card {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ant-card-bordered {\n  border: 1px solid #cfcfcf;\n}\n\n.ant-card-body {\n  @media screen and (max-width: 600px) {\n    padding: 10px 6px;\n  }\n}\n\n.ant-input-number{\n  width: 100%;\n}\n\n.ant-tooltip-inner {\n  white-space: pre-wrap;\n}\n\n.ant-checkbox .ant-checkbox-inner {\n  border-color: @button-primary-hover-color;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
